import {Component, Input, OnInit} from '@angular/core';
import {PortalService} from '../../../vna_portal/model/PortalService';
import {CampaignPrefixConfigService} from '../../services/campaign-prefix-config.service';
import {VnaCampaignPbxConfigEditComponent} from '../../modals/vna-campaign-pbx-config-edit/vna-campaign-pbx-config-edit.component';
import {ModalService} from 'ngx-dynamic-modal';
import {CampaignPrefixConfigEditComponent} from '../../modals/campaign-prefix-config-edit/campaign-prefix-config-edit.component';
import {VnaPbxConfigRemoved} from '../../model/VnaPbxConfigRemoved';
import {AlertaService} from '../../../../../shared/services/alerta.service';

@Component({
  selector: 'app-list-campaign-prefix-config',
  templateUrl: './list-campaign-prefix-config.component.html',
  styleUrls: ['./list-campaign-prefix-config.component.scss']
})
export class ListCampaignPrefixConfigComponent implements OnInit {

  @Input() portalService: PortalService;
  loading: boolean = false;

  prefixConfigs: Array<Object> = [];

  constructor(private campaignPrefixConfigService: CampaignPrefixConfigService, private modalService: ModalService, private alerts: AlertaService) { }

  ngOnInit() {
    this.getPrefixConfigs();
  }

  reloadPrefixConfigs(): void {
    this.getPrefixConfigs();
  }

  applyCallback(res: any): void {
    this.getPrefixConfigs();
  }

  newPrefixConfiguration(): void {
    this.modalService.addDynamicComponent(CampaignPrefixConfigEditComponent, {'camp' : this.portalService}, (res) => {
      this.applyCallback(res)
    });
  }

  editPrefixConfigutation(row: Object): void {
    this.modalService.addDynamicComponent(CampaignPrefixConfigEditComponent, {'camp' : this.portalService, 'element' : row}, (res) => {
      this.applyCallback(res)
    });
  }

  removePrefixConfigutation(row: Object): void {

    this.loading = true;
    const pk = row['pk'];
    this.campaignPrefixConfigService.removePrefixConfig(pk).subscribe(
      (result) => {
        const idx = this.prefixConfigs.findIndex((obj) => {
          return obj['pk'] === row['pk'];
        });

        this.prefixConfigs.splice(idx, 1);

        this.loading = false;
        this.alerts.addAlert('success', 'Prefix config has been removed successfully');
      }
    )
  }

  protected getPrefixConfigs(): void {
    this.loading = true;
    this.campaignPrefixConfigService.getPrefixConfigs(this.portalService.pkCamp).subscribe(
      (result) => {
        this.prefixConfigs = result;
        this.loading = false;
      }
    )
  }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna-campaign/components/list-campaign-prefix-config/list-campaign-prefix-config.component.ts